module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp1_0.4b15ef4f.png";